import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=35cdf97c&scoped=true&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=35cdf97c&prod&lang=scss&"
import style1 from "./toolbar.vue?vue&type=style&index=1&id=35cdf97c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdf97c",
  null
  
)

export default component.exports